import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "agent",
    "reportSection",
    "runShape",
    "targetMode",
    "targetModeLabel",
    "targetsTitle",
    "targetsHelp"
  ]

  static values = {
    agentRoles: Object
  }

  connect() {
    this.update()
  }

  update() {
    const interview = this.currentAgentRole === "interviewer"
    this.reportSectionTargets.forEach((section) => this.toggle(section, !interview))
    if (this.hasRunShapeTarget) this.toggle(this.runShapeTarget, !interview)

    this.updateTargetCopy(interview)
    this.updateTargetModeOptions(interview)
  }

  updateTargetCopy(interview) {
    if (this.hasTargetsTitleTarget) {
      this.targetsTitleTarget.textContent = interview ? "Respondents" : "Targets"
    }
    if (this.hasTargetsHelpTarget) {
      this.targetsHelpTarget.textContent = interview
        ? "Choose who should receive this interview."
        : "Choose the concrete teams or work streams this work should run for."
    }
    if (this.hasTargetModeLabelTarget) {
      this.targetModeLabelTarget.textContent = interview ? "Respondent mode" : "Target mode"
    }
  }

  updateTargetModeOptions(interview) {
    if (!this.hasTargetModeTarget) return

    const allowed = interview
      ? ["company", "selected_teams", "selected_people"]
      : ["company", "selected_teams", "selected_work_streams", "all_work_streams"]
    let selectedAllowed = false

    Array.from(this.targetModeTarget.options).forEach((option) => {
      const visible = allowed.includes(option.value)
      option.hidden = !visible
      option.disabled = !visible
      if (visible && option.selected) selectedAllowed = true
    })

    if (!selectedAllowed) {
      this.targetModeTarget.value = "company"
      this.targetModeTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  toggle(element, visible) {
    element.classList.toggle("hidden", !visible)
    element.hidden = !visible
  }

  get currentAgentRole() {
    if (!this.hasAgentTarget) return null

    return this.agentRolesValue[this.agentTarget.value]
  }
}
